import { AppWindow } from 'lucide-react';

/**
 * Shown when cotty is already open in another tab/window. The app (router,
 * terminals, workspace sync) is not mounted behind this, so the parked window
 * can't run duplicate sessions until the user takes over here.
 */
export function DuplicateWindowNotice({ onUseHere }: { onUseHere: () => void }) {
    return (
        <div className="min-h-screen w-full grid place-items-center bg-bg-0 text-text p-6">
            <div className="flex max-w-90 flex-col items-center gap-4 text-center">
                <div className="grid h-14 w-14 place-items-center rounded-2xl border border-border-faint bg-bg-1 text-text-muted">
                    <AppWindow size={24} />
                </div>
                <div>
                    <h1 className="text-[17px] font-semibold">cotty is already open</h1>
                    <p className="mt-1.5 text-[13px] leading-relaxed text-text-muted">
                        It looks like cotty is running in another tab or window.
                        Running it in two places at once can cross terminal
                        sessions and conflict on saved layouts.
                    </p>
                </div>
                <button
                    type="button"
                    onClick={onUseHere}
                    className="inline-flex h-10 items-center justify-center gap-2 rounded-xl bg-accent px-4 text-[13px] font-medium text-white transition-colors hover:bg-accent-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-bg-0"
                >
                    Use cotty here
                </button>
                <p className="text-[11px] text-text-faint">
                    The other window will switch to this notice.
                </p>
            </div>
        </div>
    );
}

export default DuplicateWindowNotice;
